import { render, staticRenderFns } from "./reserveProcessNew.vue?vue&type=template&id=4a514060&scoped=true&"
import script from "./reserveProcessNew.vue?vue&type=script&lang=js&"
export * from "./reserveProcessNew.vue?vue&type=script&lang=js&"
import style0 from "./reserveProcessNew.vue?vue&type=style&index=0&id=4a514060&prod&lang=css&"
import style1 from "./reserveProcessNew.vue?vue&type=style&index=1&id=4a514060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a514060",
  null
  
)

export default component.exports